import { BaseSerializer } from './base.serializer'
import { Interactive } from 'models/interactive.model'
import { InteractiveContentItemSerializer } from './interactive-content-item.serializer'
import { InteractiveSkillSerializer } from './interactive-skill.serializer'
import { LessonSerializer } from './lesson.serializer'

export class InteractiveSerializer extends BaseSerializer<Interactive> {

  static SERIALIZABLE_ATTRIBUTES = [
    'id', 'comment', 'folderId', 'name', 'contentItems', 'interactiveSkills', 'slug', 
    'ymetricaCode', 'deviceType', 'base', 'alredyPassed', 'driver_id', 'videoFallback',
    'fallbackLessonId'
  ]

  static SERIALIZERS = {
    contentItems: InteractiveContentItemSerializer,
    interactiveSkills: InteractiveSkillSerializer
  }

  static SERIALIZE_RENAME_KEYS = {
    contentItems: 'contentItemsAttributes',
    interactiveSkills: 'interactiveSkillsAttributes'
  }

  static DESERIALIZERS = {
    lessons: LessonSerializer,
    contentItems: InteractiveContentItemSerializer,
    interactiveSkills: InteractiveSkillSerializer
  }

  static DESERIALIZE_RENAME_KEYS = {
  }

  static initializeObject(attributes: Object): Interactive {
    return new Interactive(attributes)
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/serializers/interactive.serializer.ts